import { render, staticRenderFns } from "./category-card-subcategory.vue?vue&type=template&id=47e6c585&"
import script from "./category-card-subcategory.vue.ts?vue&type=script&lang=ts&"
export * from "./category-card-subcategory.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports